@if (value() != null) {
  {{ `labels.${value() ? 'yes' : 'no'}` | translate }}
} @else {
  -
}
